import StoreProvider from './providers';
export var create = function (services) { return function (config) {
    var store = new StoreProvider(config);
    services.observer.attach(store);
    services.postmate.listen();
    return store;
}; };
